module.exports = __webpack_public_path__ + "static/img/banner3.f4e781f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner3.jpg
// module id = O1t/
// module chunks = 1